import React, { useEffect, useState } from "react";
import FilterIcon from "../../assets/images/Svg/FilterIcon.svg";
import { Button, Modal, Select } from "antd";
import PaymentsTable from "./PaymentsTable";
import PaymentsFilter from "./PaymentsFilter";
import { CloseOutlined } from "@ant-design/icons";
import Layout from "../../Layout";
import PatientService from "../../Services/PatientService";
import { MdFamilyRestroom } from "react-icons/md";

const Payments = () => {
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [filterValues, setFilterValues] = useState(null);
  const activePatient = JSON.parse(sessionStorage.getItem("patientData"));
  const [selectedPatient, setSelectedPatient] = useState(activePatient);
  const [familyList, setFamilyList] = useState([]);

  const handleFilter = () => {
    if (filterValues) {
      setFilterValues(null);
    } else {
      setIsModalOpen1(true);
    }
  };

  const getFamilyList = async () => {
    const payload = { parentPatientId: activePatient?.patientId };
    try {
      const response = await PatientService.getPatient(payload);
      setFamilyList(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  const handlePatientChange = (value) => {
    if (value === activePatient?.patientId) {
      setSelectedPatient(activePatient);
    } else {
      const selectedPatObj = familyList.find((pat) => pat.patientId === value);
      setSelectedPatient(selectedPatObj);
    }
  };

  useEffect(() => {
    getFamilyList();
  }, []);

  const handleCloseModal = (values) => {
    setFilterValues(values || null);
    setIsModalOpen1(false);
  };

  return (
    <Layout>
      <div className="h-screen px-5 pt-5">
        <div className="flex sm:flex-col justify-between">
          <h2 className="font-bold text-lg">Payments</h2>
          <div className="flex gap-2">
            {!activePatient?.parentPatientId && (
              <div className="flex items-center gap-2 mb-3">
                <MdFamilyRestroom className="text-iconBlue" />
                <Select
                  className="w-36 h-9"
                  value={selectedPatient?.patientId}
                  onChange={handlePatientChange}
                >
                  <Select.Option value={activePatient?.patientId}>
                    {activePatient.firstName}
                  </Select.Option>
                  {familyList.length !== 0 &&
                    familyList.map((fam) => (
                      <Select.Option key={fam.patientId} value={fam.patientId}>
                        {fam.firstName}
                      </Select.Option>
                    ))}
                </Select>
              </div>
            )}
            <Button
              onClick={handleFilter}
              className="w-20 h-9 px-2 flex items-center gap-2 custom_filter"
            >
              {filterValues ? (
                <div className="flex items-center">
                  <span className="text-white mx-1">Clear</span>
                  <CloseOutlined
                    style={{ color: "white", marginLeft: "4px" }}
                  />
                </div>
              ) : (
                <div className="flex items-center">
                  <span>
                    <img src={FilterIcon} alt="Icon" />
                  </span>
                  <span className="text-white ml-2">Filter</span>
                </div>
              )}
            </Button>
          </div>
        </div>

        {/* ✅ Mobile horizontal scroll wrapper — scrollbar only, no touch swipe */}
        <div
          style={{
            overflowX: "auto",
            WebkitOverflowScrolling: "auto", // disables momentum/touch scroll
            overscrollBehaviorX: "contain",
            touchAction: "pan-y", // allows vertical scroll, blocks horizontal swipe
          }}
        >
          <div style={{ minWidth: "600px" }}>
            <PaymentsTable
              filterValues={filterValues}
              selectedPatient={selectedPatient}
            />
          </div>
        </div>
      </div>

      {isModalOpen1 && (
        <Modal
          title={
            <span className="text-base font-bold font-sans">
              Payments Filter
            </span>
          }
          visible={isModalOpen1}
          onOk={() => handleCloseModal()}
          centered={true}
          footer={null}
          onCancel={() => handleCloseModal()}
          okText="Submit"
          cancelText="Cancel"
          width={500}
          maskClosable={false}
        >
          <PaymentsFilter onClose={(values) => handleCloseModal(values)} />
        </Modal>
      )}
    </Layout>
  );
};

export default Payments;
